const CTASection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/1802e5154925bd94d3695485589be7c8.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#FF8C42]/95 to-[#D4693A]/95"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Optimize Your Logistics?
        </h2>
        <p className="text-xl text-white/90 mb-10">
          Partner with Sodrel Logistics and experience the difference that 110 years of expertise makes
        </p>
        <a
          href="tel:+13172460584"
          className="inline-block bg-white text-[#FF8C42] px-10 py-5 rounded-full text-lg font-bold hover:bg-[#FFF8F0] transition-all duration-300 shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer"
        >
          Call Us: +1 (317) 246-0584
        </a>
        <p className="text-white/80 mt-8 text-lg">
          Or email us at{' '}
          <a
            href="mailto:sodrel@michaellogistics.com"
            className="text-white font-semibold underline hover:text-[#FFF8F0] transition-colors cursor-pointer"
          >
            sodrel@michaellogistics.com
          </a>
        </p>
      </div>
    </section>
  );
};

export default CTASection;